module.exports = __webpack_public_path__ + "img/30_52.16d1d380.png";